+function ($) {
    'use strict';

    var FaqList = function (element, option) {
        this.$element = $(element);
        this.$header = this.$element.find('.faq-item__hover');
        this.$body = this.$element.find('.faq-item__body');

        var self = this;
        this.$header.bind('click', function () {
            self.toggle();
        });
    };

    FaqList.prototype.toggle = function () {
        if (this.$element.hasClass('active')) {
            this.hide();
        } else {
            this.show();
        }
    };

    FaqList.prototype.show = function () {
        this.$element.addClass('active');
        this.$body.show("slow");
    };

    FaqList.prototype.hide = function () {
        var self = this;
        this.$body.hide("slow", function () {
           self.$element.removeClass('active');
        });
    };

    var constructor = function (options) {
        //вернуть надо объект jQuery
        return this.each(function () {
            new FaqList(this, options);
        });
    };



    var old = $.fn.faqList;

    $.fn.faqList = constructor;
    $.fn.faqList.constructor = constructor;

    $.fn.faqList.noConflict = function () {
        $.fn.faqList = old;
        return this;
    }
}(jQuery);